import AnimalQuiz from "../../components/LKG/EnvironmentScience/AnimalQuiz";
import LivingNonLivingWorksheet from "../../components/LKG/EnvironmentScience/LivingNonLivingWorksheet";
import TrafficSafetyQuiz from "../../components/LKG/EnvironmentScience/TrafficSafetyWorksheet";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - LKG - Environment Science";

const topics: MenuItem[] = [
    { url: "/lkg/environmental-science/living-non-living", title: "Living & Non Living Things", component: LivingNonLivingWorksheet },
    { url: "/lkg/environmental-science/animal", title: "Animal", component: AnimalQuiz },
    { url: "/lkg/environmental-science/traffic-rules-safety", title: "Traffic Rules & Safety", component: TrafficSafetyQuiz },
];

export default topics;